import { all } from 'redux-saga/effects';

export function* globalSaga() {
  yield all([]);
}
